module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-[95]460.8981f08.woff2";